import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Privacy Policy"
      lastUpdated="December 2026"
    >
      <p>
        Mackbe Tech Ltd ("we", "us", "our") respects your privacy and is committed
        to protecting the personal information you share with us. This policy
        explains what data we collect, how we use it, and the rights you have
        under UK GDPR and the Data Protection Act 2018.
      </p>

      <h2>1. Who we are</h2>
      <p>
        Mackbe Tech Ltd is a company registered in England, with its registered
        office at 400 Thames Valley Park Dr, Earley, Reading, RG6 1PT, United
        Kingdom. You can contact us at <a href="mailto:hello@mackbetech.com">hello@mackbetech.com</a>.
      </p>

      <h2>2. What data we collect</h2>
      <ul>
        <li>Contact details you provide via our enquiry form (name, company, email, phone, project details).</li>
        <li>Communications you send to us by email or other channels.</li>
        <li>Basic analytics data (page views, device type, country) collected via privacy-respecting tooling.</li>
      </ul>

      <h2>3. How we use your data</h2>
      <ul>
        <li>To respond to your enquiry and discuss potential work together.</li>
        <li>To send you proposals, project documentation and follow-ups directly related to your enquiry.</li>
        <li>To improve the performance and content of our website.</li>
      </ul>

      <h2>4. Lawful basis</h2>
      <p>
        We process your data on the basis of legitimate interest (responding to
        business enquiries) and, where applicable, your consent. We do not sell or
        share your personal data with third parties for marketing purposes.
      </p>

      <h2>5. Data retention</h2>
      <p>
        We retain enquiry data only as long as necessary to handle your enquiry
        and any subsequent business relationship, after which it is securely
        deleted.
      </p>

      <h2>6. Your rights</h2>
      <p>
        Under UK GDPR you have the right to access, correct, delete or restrict
        processing of your personal data, and to object to processing. To exercise
        these rights please email <a href="mailto:hello@mackbetech.com">hello@mackbetech.com</a>.
      </p>

      <h2>7. Cookies</h2>
      <p>
        See our <a href="/cookies">Cookie Notice</a> for details on cookies and
        similar technologies used by this site.
      </p>

      <h2>8. Changes to this policy</h2>
      <p>
        We may update this policy from time to time. The latest version will
        always be available on this page.
      </p>

      <h2>9. Contact</h2>
      <p>
        Questions or complaints about your data: <a href="mailto:hello@mackbetech.com">hello@mackbetech.com</a>.
        You also have the right to lodge a complaint with the Information
        Commissioner's Office (ICO) at <a href="https://ico.org.uk" target="_blank" rel="noreferrer noopener">ico.org.uk</a>.
      </p>
    </LegalLayout>
  );
}
